import { SVGProps } from "react"
const SuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="60"
    height="61"
    viewBox="0 0 60 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="0.671875" width="60" height="60" rx="30" fill="#E3F8E6" />
    <path
      d="M46.6654 29.139V30.6723C46.6633 34.2663 45.4995 37.7634 43.3476 40.642C41.1956 43.5206 38.1708 45.6264 34.7243 46.6455C31.2777 47.6645 27.5941 47.5421 24.2228 46.2966C20.8515 45.0511 17.9731 42.7491 16.017 39.7341C14.0608 36.719 13.1317 33.1524 13.3682 29.5662C13.6046 25.9799 14.994 22.5662 17.3292 19.8341C19.6643 17.102 22.82 15.1979 26.3257 14.4059C29.8314 13.6138 33.4991 13.9762 36.782 15.439"
      stroke="#008015"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.6667 17.3398L30 34.0232L25 29.0232"
      stroke="#008015"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SuccessIcon
